export const BI_BASE_API_URL = process.env.REACT_APP_BI_BASE_API_URL;

// GET - Obtém  dados dos totalizadores consolidados
export const BI_GET_CONSOLIDATED_TOTALIZERS_ENDPOINT = '/benchmarking/international/consolidated/totalizers';

// GET - Obtém  dados dos indicadores consolidados
export const BI_GET_CONSOLIDATED_INDICATORS_ENDPOINT = '/benchmarking/international/consolidated/regions';

// GET - Obtém  dados dos indicadores evolutivos
export const BI_GET_EVOLUTIVE_INDICATORS_ENDPOINT = '/benchmarking/international/evolutive/regions';

// GET -  Obtém  dados dos totalizadores da tela inicial
export const BI_GET_LOGIN_TOTALIZER_ENDPOINT = '/benchmarking/international/initialPage';
